import { Body, Heading } from 'copilot-design-system';
import { PropsWithChildren } from 'react';

export const OnboardingQuestionLabel = ({
  children,
}: PropsWithChildren<{}>) => (
  <Heading className="mb-3 sm:mb-2" tag="h2">
    {children}
  </Heading>
);

export const OnboardingContentLayout = ({
  title,
  description,
  children,
}: PropsWithChildren<{
  title: string;
  description: string;
}>) => (
  <>
    <Heading className="text-black-heading leading-7 text-center" size="xl">
      {title}
    </Heading>
    <Body className="text-secondary text-center" size="lg">
      {description}
    </Body>
    <div className="flex flex-col gap-8 mt-8 sm:mt-12">{children}</div>
  </>
);
